import { Color, MaintenanceEventResult, MaintenanceEventState } from '@/types'
import { Badge, BadgeProps as BaseBadgeProps } from '../base/badge'

type BadgeColor = BaseBadgeProps['color']

type MaintenanceEvent = {
  state: MaintenanceEventState
  maintenanceType: { name: string, color: BadgeColor | Color }
  result?: MaintenanceEventResult | null
}

interface BadgeProps {
  maintenanceEvent: MaintenanceEvent
}

export const TypeBadge = ({ maintenanceEvent }: BadgeProps) => {
  const { maintenanceType } = maintenanceEvent
  const { color, name } = maintenanceType

  return <Badge color={color?.toLowerCase() as BadgeColor}>{ name.toLowerCase() }</Badge>
}

export const StateBadge = ({ maintenanceEvent }: BadgeProps) => {
  switch (maintenanceEvent.state) {
    case 'pending': return <Badge color="yellow">pending</Badge>
    case 'started': return <Badge color="blue">started</Badge>
    case 'completed': return <Badge color="green">completed</Badge>
  }
}

export const ResultBadge = ({ maintenanceEvent }: BadgeProps) => {
  if (maintenanceEvent.state != 'completed') return <Badge color="yellow">pending</Badge>

  switch (maintenanceEvent.result) {
    case MaintenanceEventResult.Passed: return <Badge color="green">passed</Badge>
    case MaintenanceEventResult.Failed: return <Badge color="red">failed</Badge>
    case MaintenanceEventResult.Quarantined: return <Badge color="orange">quarantined</Badge>
  }
}
